import type { PermissionEnum } from '@Application/Security/Roles';
import type { PermissionPayload } from '@Application/Security/Roles/Actions/userPermissionsFetched';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class PermissionsListView {
	readonly list: readonly PermissionPayload[];

	constructor(list: readonly PermissionPayload[]) {
		this.list = list;

		Object.freeze(this);
	}

	has(permission: PermissionEnum): boolean {
		return this.list.some((entry) => entry.value === permission);
	}
}

export default PermissionsListView;
